import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=3654dff9&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"
import style0 from "./agent.vue?vue&type=style&index=0&id=3654dff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654dff9",
  null
  
)

export default component.exports